<template>
  <div>
    <el-breadcrumb separator="/">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>发行管理</el-breadcrumb-item>
      <el-breadcrumb-item>定价管理</el-breadcrumb-item>
    </el-breadcrumb>
    <el-card>
      <el-row :gutter="20">
        <el-col :span="7">
          <el-button
            v-if="hasPerm('publish:price:add')"
            type="primary"
            icon="el-icon-add"
            @click="addPrice"
            >添加定价</el-button
          >
        </el-col>
      </el-row>
      <el-table
        :height="tableHeight"
        size="mini"
        :data="PriceList"
        style="width: 100%; margin-bottom: 20px"
        row-key="id"
        border
      >
        <el-table-column label="名称" prop="papername"></el-table-column>
        <el-table-column label="期数" prop="month"></el-table-column>
        <el-table-column label="价格" prop="price"></el-table-column>
        <el-table-column label="序号" prop="sort"></el-table-column>

        <el-table-column width="170" align="center" label="操作">
          <template slot-scope="scope">
            <el-button
              v-if="hasPerm('publish:price:edit')"
              type="primary"
              size="mini"
              @click="editPrice(scope.row)"
              >编辑</el-button
            >
            <el-button
              v-if="hasPerm('publish:price:delete')"
              size="mini"
              type="danger"
              @click="deletePrice(scope.row)"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>

      <!--新增价格-->
      <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" width="33%">
        <el-form
          :rules="addPriceValidate"
          :inline="true"
          size="mini"
          :model="addForm"
          ref="addForm"
          label-width="80px"
        >
          <el-form-item prop="name" label="报纸名称">
            <el-select v-model="addForm.name" placeholder="请选择">
              <el-option
                v-for="(item, index) in PaperList"
                :key="index"
                :value="item.name"
                :label="item.name"
              >
              </el-option>
            </el-select>
          </el-form-item>

          <el-form-item prop="month" label="期数">
            <el-input-number
              :min="1"
              :max="12"
              v-model="addForm.month"
              controls-position="right"
            ></el-input-number>
          </el-form-item>
          <el-form-item prop="price" label="价格">
            <el-input-number
              :min="1"
              v-model="addForm.price"
              controls-position="right"
            ></el-input-number>
          </el-form-item>

          <el-form-item label="显示序号">
            <el-input-number
              :min="0"
              v-model="addForm.sort"
              controls-position="right"
            ></el-input-number>
          </el-form-item>
        </el-form>

        <span slot="footer" class="dialog-footer">
          <el-button @click="dialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="addCommit">确 定</el-button>
        </span>
      </el-dialog>
    </el-card>
  </div>
</template>

<script>
import {
  GetPaperListByEnabled,
  GetPriceList,
  GetPriceById,
  DeletePriceById,
  AddPrice,
  EditPrice
} from "@/request/api";
export default {
  data() {
    return {
      tableHeight: 0,
      PaperList: [],
      PriceList: [],
      dialogTitle: "",
      dialogVisible: false,
      editTag: "0",

      addForm: {
        id: "", //编辑id
        name: "",
        price: 0,
        month: 0,
        sort: 0,
      },
      addPriceValidate: {
        name: [{ required: true, trigger: "blur", message: "请填写报纸名称" }],
        month: [
          {
            required: true,
            message: "请输入期数",
            type: "number",
            trigger: "blur",
          },
        ],

        price: [
          {
            required: true,
            type: "number",
            trigger: "blur",
            message: "请填写价格",
          },
        ],
      },
    };
  },
  mounted() {
    this.$nextTick(() => {
      this.tableHeight = window.innerHeight - 210; //后面的50：根据需求空出的高度，自行调整
    });
  },
  created() {
    this.getPaperList();
    this.getPriceList();
  },
  methods: {
    addPrice() {
      this.editTag = "0";
      this.dialogTitle = "新增价格";
      this.dialogVisible = true;
      //清空表单数据
      this.resetForm("addForm");
    },

    editPrice(row) {
      //设置编辑标志为1
      this.editTag = "1";
      this.boxTitle = "编辑价格";
      this.dialogVisible = true;
      //回显编辑的数据
      this.getPriceById(row.id);
    },

    // async getPriceById(id) {
    //   let parm = {
    //     id: id,
    //   };
    //   let { data: res } = await this.$http.post("/publish/getPriceById", parm);
    //   console.log("res-->", res.data);
    //   if (res.code === 1) {
    //     this.addForm.id = res.data.id;
    //     this.addForm.name = res.data.papername;
    //     this.addForm.price = res.data.price;
    //     this.addForm.month = res.data.month;
    //     this.addForm.sort = res.data.sort;
    //   }
    // },

    getPriceById(id) {
      let param = {
        id: id,
      };
      GetPriceById(param).then((res) => {
        if (res.data.code === 1) {
          this.addForm.id = res.data.data.id;
          this.addForm.name = res.data.data.papername;
          this.addForm.price = res.data.data.price;
          this.addForm.month = res.data.data.month;
          this.addForm.sort = res.data.data.sort;
        }
      });
    },

    deletePrice(row) {
      this.deletePriceById(row);
    },

    async deletePriceById(row) {
      this.$confirm("确定删除吗 ?", "系统提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(async () => {
        let param = {
          id: row.id,
        };
        DeletePriceById(param).then((res) => {
          if (res.data.code === 1) {
            this.getPriceList();
            this.$message({
              message: res.data.msg,
              type: "success",
            });
          }
        });
      });
    },

    // async deletePriceById(row) {
    //   let _this = this;
    //   _this
    //     .$confirm("确定删除吗 ?", "系统提示", {
    //       confirmButtonText: "确定",
    //       cancelButtonText: "取消",
    //       type: "warning",
    //     })
    //     .then(async () => {
    //       let param = {
    //         id: row.id,
    //       };
    //       let { data: res } = await _this.$http.post(
    //         "publish/deletePriceById",
    //         param
    //       );
    //       console.log("res---->", res);
    //       if (res.code == 1) {
    //         //刷新表格数据
    //         _this.getPriceList();
    //       }
    //       _this.$message({
    //         message: res.msg,
    //         type: "success",
    //       });
    //     });
    // },

    getPaperList() {
      GetPaperListByEnabled().then((res) => {
        if (res.data.code === 1) {
          this.PaperList = res.data.data;
        }
      });
    },

    // async getPaperList() {
    //   const { data: res } = await this.$http.post(
    //     "/publish/getPaperListByEnabled"
    //   );
    //   console.log("Paperlist-->", res);
    //   if (res.code === 1) {
    //     this.PaperList = res.data;
    //   }
    // },
    getPriceList() {
      GetPriceList().then((res) => {
        if (res.data.code === 1) {
          this.PriceList = res.data.data;
        }
      });
    },
    // async getPriceList() {
    //   const { data: res } = await this.$http.post("/publish/getPriceList");
    //   console.log(res);
    //   if (res.code === 1) {
    //     this.PriceList = res.data;
    //   }
    // },
    //解决重置表单时报 'resetFields' of undefined的错
    resetForm(formName) {
      if (this.$refs[formName]) {
        this.$refs[formName].resetFields();
      }
    },

    addCommit() {
      this.$refs.addForm.validate(async (valid) => {
        if (valid) {
          if (this.editTag === "0") {
            AddPrice(this.addForm).then((res) => {
              if (res.data.code === 1) {
                this.getPriceList();
                this.dialogVisible = false;
              }
            });
          } else {
            EditPrice(this.addForm).then((res) => {
              if (res.data.code === 1) {
                this.getPriceList();
                this.dialogVisible = false;
              }
            });
          }
  
        }
 
      });
    },
    // addCommit() {
    //   let _this = this;
    //   _this.$refs.addForm.validate(async (valid) => {
    //     if (valid) {
    //       let parm = _this.addForm;
    //       let url = "";
    //       if (_this.editTag == "0") {
    //         url = "/publish/addPrice";
    //       } else {
    //         url = "/publish/editPrice";
    //       }
    //       console.log("param--->", parm);
    //       let { data: res } = await _this.$http.post(url, parm);
    //       if (res.code === 1) {
    //         _this.getPriceList();
    //         _this.$message({
    //           message: res.msg,
    //           type: "success",
    //         });
    //       } else {
    //         _this.$message({
    //           message: res.msg,
    //           type: "error",
    //         });
    //       }
    //     }
    //     _this.dialogVisible = false;
    //   });
    // },
  },
};
</script>

<style lang="scss" scoped>
</style>